export type EmptyLoanNumber = { status: 'empty' };
export type InvalidLoanNumber = { status: 'invalid'; value: string };
export type ValidLoanNumber = { status: 'valid'; value: number };
export type LoanNumber = EmptyLoanNumber | InvalidLoanNumber | ValidLoanNumber;

const empty = (): EmptyLoanNumber => ({ status: 'empty' });
const valid = (value: number): ValidLoanNumber => ({ status: 'valid', value });
const invalid = (value: string): InvalidLoanNumber => ({ status: 'invalid', value });

// eslint-disable-next-line no-redeclare
export const LoanNumber = {
  empty,
  valid,
  invalid
};
